import api from "../api/api";

export async function logout() {
  try {
    await api.post("/auth/logout");
  } catch (err) {
    console.error("Logout error:", err);
  } finally {
    window.location.href = "/login";
  }
}